<sim-basic-material-dialog
	(closeClicked)="close({action: 'cancel'})"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-folder-tree', fontSet: 'fad'}"
	[headerText]="T.EXAM_FLOW_DETAIL_DIALOG_HEADER | translate"
	[matDialogData]="data"
	[overflowHandledByChild]="true"
	[rect]="rect"
	[smallHeader]="true"
>
	<ng-container dialogContent>
		<section class="metadata mat-elevation-z1">
			<label class="primary">{{ examFlow.name }}</label>
			<p class="secondary">{{ examFlow.description }}</p>
			<div class="participantDevices">
				<mat-icon class="secondary firstIcon" fontIcon="fa-users" fontSet="fas" />
				@for (participantDevice of examFlow.examFlowParticipantDevices; track participantDevice.participantType) {
					<mat-chip [class.present]="participantDevice.isPresent" class="mat-elevation-z1">
						<mat-icon
							[fontIcon]="participantDevice.isPresent ? 'fa-check-circle' : 'fa-times-circle'"
							matChipAvatar
							[fontSet]="isDarkTheme ? 'fas' : 'far'"
						/>
						<label>
							@switch (participantDevice.participantType) {
								@case (ParticipantType.Learner) {
									{{ T.EXAM_ROLE_ExamStudentInsidePc | translate }}
								}
								@case (ParticipantType.Instructor) {
									{{ T.EXAM_ROLE_ExamExaminerPc | translate }}
								}
								@case (ParticipantType.StandardizedPatient) {
									{{ T.EXAM_ROLE_ExamStandardizedPatientPc | translate }}
								}
							}
						</label>
					</mat-chip>
				}
			</div>
		</section>
		<section class="phaseList">
			@for (phase of examFlow.examPhases; track phase) {
				@if (phase.isActive) {
					<sim-phase-nav-button [phase]="phase" [audioElement]="audio" />
				}
			}
		</section>
	</ng-container>
	<ng-container actions>
		@if (showEditButton()) {
			<sim-button
				(onClick)="navigateToEdit()"
				[hasPermission]="Permissions.Create_Exam_Session"
				[icon]="{fontIcon: 'fa-edit', fontSet: 'fas'}"
				[label]="T.BUTTON_EDIT"
				variant="raised"
			/>
		}
		<sim-button
			(onClick)="close({action: 'close'})"
			[icon]="{fontIcon: 'fa-times', fontSet: 'fas'}"
			[label]="T.BUTTON_CLOSE"
			color="warn"
		/>
	</ng-container>
</sim-basic-material-dialog>

<sim-audio-element #audio />

<!--NG-TEMPLATE-->
<ng-template #chip let-context>
	<mat-chip>
		<mat-icon class="secondary" [fontIcon]="context.icon" [fontSet]="isDarkTheme ? 'fas' : 'far'" matChipAvatar />
		<label class="secondary">{{ context.label | translate }} </label>
	</mat-chip>
</ng-template>
